import Bugsnag, { BreadcrumbType } from '@bugsnag/js';

export const reportError = (e: Error) => window.env.RIDEIQ_BUGSNAG_API_KEY && Bugsnag.notify(e);

export const leaveBreadcrumb = (message: string, metadata?: { [key: string]: unknown }, type?: BreadcrumbType) =>
  window.env.RIDEIQ_BUGSNAG_API_KEY && Bugsnag.leaveBreadcrumb(message, metadata, type);
